<mat-dialog-content class="mat-typography">
    <h3>{{data.header}}</h3>
    <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="data.type" cdkFocusInitial >Proceed</button>
    <button mat-button [mat-dialog-close]="false" mat-dialog-close >Cancel</button>
</mat-dialog-actions>